module.exports = "https://cdn.landi.com/assets/peilian/offical_website_pc/1.0.41/images/ccc08692d3a1533b998177d005679a49.png";